module.exports = __webpack_public_path__ + "media/images/official/referral_kv-ad0287f225d0bc1b5429263dbaad478f.svg";